import { CreateCardAllowance, CreateCardShippingAddress } from '../interfaces/CardsGatewayInterfaces';

//omitting some keys which are readonly
type CreateCardKeys = keyof Omit<CreateCardAllowance, 'remainingBalance' | 'balanceResetsAt'> | keyof CreateCardShippingAddress;

//If gateway returns an error with any of these keys, we will map it to a generic message
//otherwise we will just display the error
export const GATEWAY_ERROR_MAP: Partial<Record<CreateCardKeys, string>> = {
  interval: 'Frequency',
  intervalAmount: 'Budget',
  transactionLimit: 'Transaction limit',
  startDate: 'Start date',
  endDate: 'End date',
  allowedCategories: 'Allowed Merchant Categories',
  allowedCategoryGroups: 'Allowed Merchant Category Groups',
  allowedVendor: 'Allowed Vendors',
  attn: 'Recipient Name in Shipping Address',
  address1: 'Street Address in Shipping Address',
  address2: 'Street Address in Shipping Address',
  city: 'City in Shipping Address',
  state: 'State in Shipping Address',
  country: 'Country in Shipping Address',
  zipCode: 'Postal Code in Shipping Address'
};

export const parseCardsGatewayError = (error: string | undefined) => {
  if (!error) {
    return [];
  }

  const errors: string[] = [];

  function getErrorMessage(key: string, obj: any) {
    if (key in GATEWAY_ERROR_MAP) {
      errors.push(`${(GATEWAY_ERROR_MAP as any)[key]} is invalid`);
      return;
    }

    if (typeof obj === 'string') {
      errors.push(obj);
      return;
    }

    Object.keys(obj).forEach((objKey) => {
      getErrorMessage(objKey, obj[objKey]);
    });
  }

  try {
    const errorObject = JSON.parse(error);

    getErrorMessage('', errorObject);

    return errors;
  } catch (e) {
    return [error];
  }
};
